<template>
  <div class="wrapper">
    <SwitchLocaleComponent class="switch-locale"/>
    
    <img src="@/assets/images/knb_logo.png" alt="">
    <img src="@/assets/images/saqshy_logo.png" alt="">
    <form @submit.prevent="login" novalidate>
      <h1>{{$t("message.login")}}</h1>
      <div class="input-item">
        <h2>{{$t("message.IIN")}} <span>*</span></h2>
        <input
          v-model.trim="iin"
          type="text"
          inputmode="numeric"
          autocomplete="username"
          placeholder="123456789012"
          maxlength="12"
          @input="onIinInput"
        />
      </div>

      <div class="input-item">
        <h2>{{$t("message.password")}} <span>*</span></h2>
        <input v-model="password" type="password" placeholder="" />
      </div>

      <button type="submit">{{$t("message.login")}}</button>
      <p v-if="error" style="color:#E03137; margin-top: 8px;">{{ error }}</p>
    </form>
  </div>
</template>

<script>
import SwitchLocaleComponent from '@/components/locales/SwitchLocaleComponent.vue'
import { login as apiLogin } from '@/middlewares/auth'
import { ensureCurrentUser } from '@/api/user'
import { getDefaultPathForUser } from '@/access/armAccess'

export default {
  name: 'LoginPage',
  components: {
    SwitchLocaleComponent
  },
  data() {
    return {
      iin: '',
      password: '',
      error: ''
    }
  },
  methods:{
    onIinInput(e) {
      const raw = String(e?.target?.value ?? '')
      const digitsOnly = raw.replace(/\D+/g, '').slice(0, 12)
      if (digitsOnly !== this.iin) this.iin = digitsOnly
    },
    async login() {
      this.error = ''
      if (!/^\d{12}$/.test(this.iin)) {
        this.error = this.$t('login.iinFormatError')
        return
      }
      try {
        await apiLogin({ iin: this.iin, password: this.password })
        const user = await ensureCurrentUser()
        const fallback = getDefaultPathForUser(user)
        const redirect = this.$route.query?.redirect || fallback
        this.$router.push(redirect)
      } catch (e) {
        this.error = e?.payload?.detail || e?.message || this.$t('login.authError')
      }
    }
  }
}
</script>

<style lang="sass" scoped>
@import url('https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700&display=swap')


.wrapper
  background-color: #12203B
  width: 100vw
  height: 100vh
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
  img
    margin: 2vh 0 2vh 0
  .switch-locale
    position: absolute
    top: 20px
    right: 20px
  form
    width: 34vw
    height: 44vh
    background-color: #FBFCFE
    border: 2px solid #33B4F9
    border-radius: 15px
    display: flex
    flex-direction: column
    align-items: center
    h1
      font-family: 'Manrope', sans-serif
      font-weight: 700
      font-size: 1.6rem
      margin-bottom: 0
    .input-item
      width: 80%
      h2
        font-family: 'Manrope', sans-serif
        font-weight: 500
        font-size: 1rem
        span
          color: rgba(224, 49, 55, 1)
      input
        width: 95%
        padding: 15px 10px 15px 10px
        border: 1px solid rgba(233, 234, 236, 1)
        border-radius: 5px
        font-size: 1rem
        font-family: 'Times New Roman', Times, serif
    button
      width: 80%
      background-color: rgba(58, 178, 243, 1)
      color: white
      border: none
      height: 15%
      border-radius: 10px
      margin-top: 2vh
      cursor: pointer
      font-size: 1rem
      font-family: Arial, Helvetica, sans-serif
      font-weight: 700


</style>
